module.exports = __webpack_public_path__ + "img/resources-hero.4faeb889.png";